const init={}
export const TableComponentData = (state=init, action) => { 
    switch (action.type) {
         case 'tableComponentData':
              return state = action.payload
              
         default:
              return state
    }
}